import { render, staticRenderFns } from "./agent-attachment-list.vue?vue&type=template&id=f8350c9c&scoped=true"
import script from "./agent-attachment-list.vue?vue&type=script&lang=js"
export * from "./agent-attachment-list.vue?vue&type=script&lang=js"
import style0 from "./agent-attachment-list.vue?vue&type=style&index=0&id=f8350c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8350c9c",
  null
  
)

export default component.exports